import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Avatar, Box, Stack, Typography } from "@mui/material";
import { TeamColorsCircle } from "../teams/TeamColors";
/**
 * A centered match score display with team avatars.
 * Shows team colors when no logo is available.
 */
export var MatchScoreDisplay = function (_a) {
    var homeTeamProp = _a.homeTeam, awayTeamProp = _a.awayTeam, homeScore = _a.homeScore, awayScore = _a.awayScore, _b = _a.showAvatars, showAvatars = _b === void 0 ? true : _b, _c = _a.avatarSize, avatarSize = _c === void 0 ? 40 : _c, _d = _a.variant, variant = _d === void 0 ? "standard" : _d;
    var homeTeam = homeTeamProp;
    var awayTeam = awayTeamProp;
    var hasScore = homeScore !== null && homeScore !== undefined;
    var getVariantStyles = function () {
        switch (variant) {
            case "compact":
                return {
                    teamNameVariant: "body2",
                    scoreVariant: "body1",
                    spacing: 1,
                };
            case "large":
                return {
                    teamNameVariant: "h5",
                    scoreVariant: "h4",
                    spacing: 2,
                };
            default:
                return {
                    teamNameVariant: "body1",
                    scoreVariant: "h6",
                    spacing: 1.5,
                };
        }
    };
    var styles = getVariantStyles();
    var renderTeamAvatar = function (team) {
        if (!showAvatars)
            return null;
        if (team.logo) {
            return (_jsx(Avatar, { alt: team.name, src: team.logo, sx: { width: avatarSize, height: avatarSize } }));
        }
        return (_jsx(Avatar, { sx: {
                width: avatarSize,
                height: avatarSize,
                bgcolor: "transparent",
                overflow: "hidden",
                p: 0,
            }, children: _jsx(TeamColorsCircle, { color1: team.primaryColour || "#6c757d", color2: team.secondaryColour || "#adb5bd" }) }));
    };
    return (_jsxs(Stack, { direction: "row", alignItems: "center", justifyContent: "center", spacing: styles.spacing, children: [_jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1, sx: { flex: 1, justifyContent: "flex-end" }, children: [_jsx(Typography, { variant: styles.teamNameVariant, fontWeight: 500, noWrap: true, sx: { textAlign: "right" }, children: homeTeam.name }), renderTeamAvatar(homeTeam)] }), _jsx(Box, { sx: { px: 1, minWidth: 60, textAlign: "center" }, children: _jsx(Typography, { variant: styles.scoreVariant, fontWeight: hasScore ? 700 : 400, color: hasScore ? "text.primary" : "text.secondary", children: hasScore ? "".concat(homeScore, " - ").concat(awayScore) : "v" }) }), _jsxs(Stack, { direction: "row", alignItems: "center", spacing: 1, sx: { flex: 1, justifyContent: "flex-start" }, children: [renderTeamAvatar(awayTeam), _jsx(Typography, { variant: styles.teamNameVariant, fontWeight: 500, noWrap: true, sx: { textAlign: "left" }, children: awayTeam.name })] })] }));
};
